module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/paymentresponse/paymentresponse.component.scss
// module id = ./src/app/paymentresponse/paymentresponse.component.scss
// module chunks = main